<template>
  <select
    class="orm-select orm-minaboselect"
    @focus="open($event)"
    @change="
      setValue($event);
      select($event);
    "
    style="background: transparent;border: 0;"
  >
    <option
      :selected="selected == option.value"
      v-for="option in myOptions"
      :key="option"
      :value="option.value"
      >{{ option.key }} {{ i18n("general/abo_unit") || "Monate" }}</option
    >
  </select>
</template>

<script>
// import store from "@/store";
import { buildDataLayer } from "@/constants/analytics";
import i18n from "@/mixins/mixins";
export default {
  name: "SimpleSelect",
  emits: ["selected"],
  props: {
    myOptions: {
      required: true,
    },
    selected: {
      required: true,
    },
  },
  data() {
    return {
      showOptions: false,
    };
  },
  mixins: [i18n],
  methods: {
    setValue(event) {
      this.$emit("selected", event.target.value);
    },
    open(option) {
      const text =
        option.srcElement.options[option.srcElement.selectedIndex].text;
      buildDataLayer("dropdown_open", text, "minaboselect");
    },
    select(option) {
      const text =
        option.srcElement.options[option.srcElement.selectedIndex].text;
      //  + ' ' + i18n('general/abo_unit') || 'Monate'
      buildDataLayer("dropdown_select", text, "minaboselect");
      option.target.blur();
    },
  },
};
</script>
